import { BRAND_NAME, waLink, WA_GENERAL_MESSAGE } from "../data/site";

export const Navbar = () => {
  return (
    <nav
      data-testid="main-nav"
      className="sticky top-0 z-50 bg-bone/90 backdrop-blur-md border-b border-ink/10 px-6 py-4"
    >
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-3">
          <svg className="w-7 h-7 text-cognac" viewBox="0 0 32 32" fill="none" aria-hidden="true">
            <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
            <path
              d="M11 16C11 11 16 9 16 16C16 23 21 21 21 16"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
          <span className="font-display text-xl tracking-tight font-semibold">{BRAND_NAME}</span>
        </a>
        <div className="flex items-center gap-6">
          <a
            href="#vetrina"
            data-testid="nav-link-vetrina"
            className="text-xs uppercase tracking-[0.14em] font-medium hover:text-cognac transition-colors hidden sm:inline"
          >
            Vetrina Capi
          </a>
          <a
            href="#come-funziona"
            data-testid="nav-link-spedizioni"
            className="text-xs uppercase tracking-[0.14em] font-medium hover:text-cognac transition-colors hidden sm:inline"
          >
            Spedizioni
          </a>
          <a
            href="#dove-trovarci"
            data-testid="nav-link-dove-trovarci"
            className="text-xs uppercase tracking-[0.14em] font-medium hover:text-cognac transition-colors hidden sm:inline"
          >
            Dove Trovarci
          </a>
          <a
            href={waLink(WA_GENERAL_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-cta-whatsapp"
            className="inline-flex items-center gap-2 bg-ink text-bone px-5 py-2.5 rounded-full text-xs uppercase tracking-[0.14em] font-medium hover:bg-cognac transition-colors"
          >
            <span>Scrivici su WhatsApp</span>
          </a>
        </div>
      </div>
    </nav>
  );
};
